// extracted by mini-css-extract-plugin
module.exports = {"base":"HamburgerMenuButton_base__u7dU2","icon":"HamburgerMenuButton_icon__Xogmv"};